module.exports = "##### Orange\n"